import { FormFieldTypes, validationTypes } from "@repo/design-system/components/forms/libs";

export const buildSocialMediaLinkFormConfig = () => ({
    name: "Social Media Link",
    initialState: {
        profileUrl: "",
    },
    section: [
        {
            title: "",
            style: { sectionStyle: "" },
            rowGroup: [
                {
                    style: { groupStyle: "row" },
                    fields: [
                        {
                            id: "profileUrl",
                            label: "Profile URL",
                            Field_Name: "Profile URL",
                            fieldType: FormFieldTypes?.INPUT ?? 1,
                            dataField: "profileUrl",
                            fieldSetting: {
                                placeholder: "Enter your profile URL",
                                iconConfig: { icon: "ph:link-bold" },
                            },
                            validation: [
                                { type: validationTypes?.REQUIRE ?? "require" },
                                { type: validationTypes?.WEBSITE ?? "website" },
                            ],
                            style: { containerCss: "col-12 mb-0" },
                        },
                    ],
                },
            ],
        },
    ],
});

export const SocialMediaLinkFormConfig = {
    name: "Social Media Link",
    initialState: {
        profileUrl: "",
    },
    _section: null,
    get section() {
        return this._section || buildSocialMediaLinkFormConfig().section;
    },
    set section(value) {
        this._section = value;
    },
};
